import React from 'react';

interface ConfettiTriangleSVGProps {
  color?: string;
  size?: string;
  className?: string;
  isInverted?: boolean;
  style?: React.CSSProperties;
}

export const ConfettiTriangleSVG: React.FC<ConfettiTriangleSVGProps> = ({
  color = '#facc15',
  size = 'h-2 w-2',
  className = '',
  isInverted = false,
  style
}) => {
  const points = isInverted ? '0,0 16,0 8,16' : '8,0 0,16 16,16';

  return (
    <svg
      className={`${size} ${className}`}
      style={style}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <polygon points={points} fill={color} />
    </svg>
  );
};
